export const COMMENTS_LOADING = 'COMMENTS_LOADING';
export const ALL_COMMENTS = 'ALL_COMMENTS';
export const ITEM_COMMENTS = 'ITEM_COMMENTS';
export const COMMENTS_ERROR = 'COMMENTS_ERROR';
export const COMMENTS_RESET = 'COMMENTS_RESET';
export const COMMENTS_SUCCESS = 'COMMENTS_SUCCESS';
